import { defineComponent, ref, createVNode, inject, toRaw } from 'vue'
import { Collapse, CollapseItem } from 'vant'
import { get, last, head } from 'lodash'
import qs from 'qs'
import { mainPath } from '@/consts'
import { doJump } from '@/utils/nativeFn'
import './style.less'
const bodyScrollTo = (top = 0) => {
  // if (document.querySelector('.contents-list')) {
  //   document.querySelector('.contents-list').scrollTo({
  //     top: top - 52,
  //     left: 0,
  //     behavior: 'smooth'
  //   })
  // }
}
const createRightIcon = (type = 'up') => {
  let iconSrc =
    type === 'up'
      ? require('@/assets/images/weeksStudy/up.png')
      : require('@/assets/images/weeksStudy/down.png')
  let vnode = (
    <div
      style={{
        width: '20px',
        height: '20px'
      }}
    >
      <img width="20" src={iconSrc} alt="" srcset="" />
    </div>
  )
  return createVNode(vnode)
}
// 递归组件
const SubItemComponent = defineComponent({
  props: {
    data: {
      default: () => [],
      type: Array
    },
    index: Number
  },
  setup(props) {
    let actives = ref('')
    // actives.value = get(props, 'data', []).map((item) => item.key)
    return () => {
      let renderRightIcon = function (key) {
        // if (props.index >= 2) {
        //   return null
        // }
        return actives.value === key ? createRightIcon('up') : createRightIcon('down')
      }
      return (
        <>
          <Collapse v-model={actives.value} border={false} accordion>
            {get(props, 'data', []).map((item: any, i) => {
              return (
                <CollapseItem
                  // readonly={props.index >= 2 ? true : false}
                  class="sub_item_wrap"
                  title={item.name}
                  name={item.id}
                  v-slots={{
                    'right-icon': () => renderRightIcon(item.id),
                    title: () =>
                      createVNode(
                        <span
                          class="sub_item__title"
                          style={{
                            paddingLeft: `${get(props, 'index', 1) * 10}px`
                          }}
                        >
                          {item.name}
                        </span>
                      )
                  }}
                  onClick={function (e) {
                    e.stopPropagation()
                    let target = e.target
                    do {
                      target = target.parentNode
                      console.log(target.classList.contains('sub_item_wrap'))
                    } while (target.classList.contains('sub_item_wrap') === false)
                    console.log(target)
                    if (actives.value === item.id) {
                      let rect = target.getBoundingClientRect()
                      let top = document.querySelector('.contents-list').scrollTop + rect.top
                      let clickLocation = e.clientY / window.innerHeight
                      if (clickLocation > 0.85) {
                        setTimeout(() => {
                          bodyScrollTo(top)
                        }, 500)
                      }
                    }
                  }}
                >
                  {get(item, 'knowledge', []).length
                    ? item.knowledge.map((v) => (
                        <Content
                          title={v.lkName}
                          index={get(props, 'index', 1) + 1}
                          {...v}
                          onClick={function () {}}
                        />
                      ))
                    : null}
                  {get(item, 'childList', []).length ? (
                    <SubItemComponent data={item.childList} index={get(props, 'index', 1) + 1} />
                  ) : null}
                </CollapseItem>
              )
            })}
          </Collapse>
        </>
      )
    }
  }
})

// 内容部分

const Content = defineComponent((props, { attrs }) => {
  const searchState = inject('searchState')
  const subjectId = inject('subjectId')
  const gradeId = inject('gradeId')
  const $xesLog = inject('$xesLog') as any // 埋点
  return () => (
    <div class="content_cell">
      <div
        class="van-hairline--top content"
        onClick={function (e) {
          e.stopPropagation()
        }}
      >
        <div
          class="sub_item__title "
          style={{
            paddingLeft: `${(attrs.index as number) * 10}px`
          }}
        >
          {get(attrs, 'title', '')}
        </div>
        <div
          class="content_btn"
          onClick={function (e) {
            e.stopPropagation()
            console.log('点到了用来跳转', attrs, searchState, subjectId)
            let params = {
              gradeGroupId: head(toRaw((searchState as any).submitSearchValues)),
              subjectId: subjectId,
              gradeId,
              catalogueId: last(toRaw((searchState as any).submitSearchValues)),
              lkId: attrs.lkId,
              lkcId: attrs.lkcId,
              source_location: 'itembank',
              lkName: attrs.title,
              hideNavBar: 1
            }
            console.log(params)
            let toPath = `${mainPath}#/WeeksStudy/exercises/?${qs.stringify(params)}`
            console.log(toPath)
            const path = `10001?parameters=${encodeURIComponent(
              JSON.stringify({
                url: toPath
              })
            )}`
            $xesLog.track(
              'itembank_test_click',
              { page_name: 'itembank', event_type: 'click' },
              () => {}
            )
            doJump(path, () => {
              console.log('跳转成功')
            })
          }}
        >
          去练习
        </div>
      </div>
    </div>
  )
})

// 外层使用

const ContentsItem = defineComponent({
  props: {
    item: Object
  },
  emits: ['change'],
  setup(props, { emit, expose }) {
    let activeNames = ref([])
    let renderRightIcon = function () {
      return activeNames.value.length ? createRightIcon('up') : createRightIcon('down')
    }
    expose({ activeNames, curItem: props.item })
    return () => {
      return (
        <div class="contents_item">
          <Collapse
            v-model={activeNames.value}
            border={false}
            class="contents_item__collapse"
            onChange={function (e) {
              console.log(e)
              if (e.length) {
                emit('change', props.item.id)
              }
            }}
          >
            <CollapseItem
              v-slots={{
                'right-icon': renderRightIcon,
                title: () =>
                  createVNode(<span class="contents_item__title">{props.item.name}</span>)
              }}
              class="test"
              name={props.item.id}
              onClick={function (e) {
                console.log(e.clientY / window.innerHeight)
                let clickLocation = e.clientY / window.innerHeight
                setTimeout(() => {
                  let target = e.target
                  do {
                    target = target.parentNode
                  } while (target.className !== 'contents_item')
                  console.log(clickLocation)
                  if (clickLocation > 0.81) {
                    activeNames.value.length && bodyScrollTo(target.offsetTop)
                  }
                }, 600)
              }}
            >
              {get(props, 'item.knowledge', []).length
                ? props.item.knowledge.map((v) => <Content title={v.lkName} index={1} {...v} />)
                : null}
              {get(props, 'item.childList', []).length ? (
                <SubItemComponent data={props.item.childList} index={1} />
              ) : null}
            </CollapseItem>
          </Collapse>
        </div>
      )
    }
  }
})

export default ContentsItem
